export const ttCode = `CIEJ1LJC77U441D19LNG`;